import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _map from "lodash/map";
import _sum from "lodash/sum";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import fetchAPI from 'utils/http/fetchAPI';
import putInS3 from 'utils/upload/putInS3';
var PART_COUNT_MAX = 10000;
var PART_SIZE_MIN = 5 * 1024 * 1024;
var _uploadParams = /*#__PURE__*/new WeakMap();
var _abortController = /*#__PURE__*/new WeakMap();
var _partSize = /*#__PURE__*/new WeakMap();
var _partUploadLock = /*#__PURE__*/new WeakMap();
var _accumulatedChunks = /*#__PURE__*/new WeakMap();
var _uploadedParts = /*#__PURE__*/new WeakMap();
var _executeUpload = /*#__PURE__*/new WeakMap();
var _getAccumulatedUploadSize = /*#__PURE__*/new WeakMap();
var _getSignedUrlForPart = /*#__PURE__*/new WeakMap();
var PartUploader = /*#__PURE__*/_createClass(function PartUploader(uploadParams, abortController, fileSize, uploadedParts) {
  var _this = this;
  _classCallCheck(this, PartUploader);
  _classPrivateFieldInitSpec(this, _uploadParams, void 0);
  _classPrivateFieldInitSpec(this, _abortController, void 0);
  _classPrivateFieldInitSpec(this, _partSize, void 0);
  _classPrivateFieldInitSpec(this, _partUploadLock, void 0);
  _classPrivateFieldInitSpec(this, _accumulatedChunks, []);
  _classPrivateFieldInitSpec(this, _uploadedParts, void 0);
  _defineProperty(this, "uploadChunk", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(chunk, onUploadProgress) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return navigator.locks.request(_classPrivateFieldGet(_partUploadLock, _this), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var canUpload;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _classPrivateFieldGet(_accumulatedChunks, _this).push({
                          chunk: chunk,
                          onUploadProgress: onUploadProgress
                        });

                        // Upload if we have accumulated partSize
                        canUpload = _classPrivateFieldGet(_getAccumulatedUploadSize, _this).call(_this) > _classPrivateFieldGet(_partSize, _this);
                        if (canUpload) {
                          _context.next = 4;
                          break;
                        }
                        return _context.abrupt("return");
                      case 4:
                        _context.next = 6;
                        return _classPrivateFieldGet(_executeUpload, _this).call(_this);
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "finishUpload", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_classPrivateFieldGet(_accumulatedChunks, _this).length > 0)) {
              _context3.next = 3;
              break;
            }
            _context3.next = 3;
            return _classPrivateFieldGet(_executeUpload, _this).call(_this);
          case 3:
            return _context3.abrupt("return", _classPrivateFieldGet(_uploadedParts, _this));
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
  _classPrivateFieldInitSpec(this, _executeUpload, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var partNumber, mergedChunks, mergedOnUploadProgresses, partResponse;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            partNumber = _classPrivateFieldGet(_uploadedParts, _this).length + 1;
            mergedChunks = new Uint8Array(_classPrivateFieldGet(_getAccumulatedUploadSize, _this).call(_this));
            mergedOnUploadProgresses = [];
            _classPrivateFieldGet(_accumulatedChunks, _this).reduce(function (offset, _ref5) {
              var chunk = _ref5.chunk,
                onUploadProgress = _ref5.onUploadProgress;
              mergedChunks.set(chunk, offset);
              mergedOnUploadProgresses.push(onUploadProgress);
              return offset + chunk.length;
            }, 0);
            _context5.next = 6;
            return putInS3(mergedChunks, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      return _context4.abrupt("return", _classPrivateFieldGet(_getSignedUrlForPart, _this).call(_this, partNumber));
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })), _classPrivateFieldGet(_abortController, _this), function (progress) {
              return mergedOnUploadProgresses.forEach(function (cb) {
                return cb(progress);
              });
            });
          case 6:
            partResponse = _context5.sent;
            _classPrivateFieldSet(_accumulatedChunks, _this, []);
            _classPrivateFieldGet(_uploadedParts, _this).push({
              ETag: partResponse.headers.etag,
              PartNumber: partNumber
            });
          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })));
  _classPrivateFieldInitSpec(this, _getAccumulatedUploadSize, function () {
    return _sum(_map(_classPrivateFieldGet(_accumulatedChunks, _this), 'chunk.length'));
  });
  _classPrivateFieldInitSpec(this, _getSignedUrlForPart, /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(partNumber) {
      var _classPrivateFieldGet2, projectId, uploadId, bucket, key, url;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _classPrivateFieldGet2 = _classPrivateFieldGet(_uploadParams, _this), projectId = _classPrivateFieldGet2.projectId, uploadId = _classPrivateFieldGet2.uploadId, bucket = _classPrivateFieldGet2.bucket, key = _classPrivateFieldGet2.key;
              url = "/v2/projects/".concat(projectId, "/upload/").concat(uploadId, "/part/").concat(partNumber, "/signedUrl");
              _context6.next = 4;
              return fetchAPI(url, {
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                  bucket: bucket,
                  key: key
                })
              });
            case 4:
              return _context6.abrupt("return", _context6.sent);
            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }());
  _classPrivateFieldSet(_uploadParams, this, uploadParams);
  _classPrivateFieldSet(_abortController, this, abortController);

  // Can't have more than 10000 parts
  var minPartSize = Math.ceil(fileSize / PART_COUNT_MAX);
  // Can't have parts be size less than 5MB
  _classPrivateFieldSet(_partSize, this, Math.max(minPartSize, PART_SIZE_MIN));
  _classPrivateFieldSet(_partUploadLock, this, "partUploadLock".concat(_classPrivateFieldGet(_uploadParams, this).uploadId));
  _classPrivateFieldSet(_uploadedParts, this, uploadedParts);
});
export default PartUploader;